export enum StartDateTypeEnum {
  IMMEDIATELY = "Start immediately",
  AFTER_CURRENT_ITEM = "Start after the current item",
  ON_SELECTED_DATE = "Start on a specific date",
}
